// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // BASE_URL: 'https://backend.your-te.com/api/',
  // host: 'https://backend.your-te.com/',
  // profileBaseUrl: 'https://teconnectivity-bucket.s3.us-east-2.amazonaws.com/profile-image/',
  BASE_URL: 'https://auto-backend.te.com/api/',
  host: 'https://auto-backend.te.com/',
  profileBaseUrl: 'https://yte-data-connectivity-prod.s3.amazonaws.com/profile-image/',
  appName: 'TE to Go',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
